<template>
  <div class="account-pages my-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <div class="card overflow-hidden">
            <div class="bg-soft-primary">
              <div class="row">
                <div class="col-7">
                  <div class="text-primary p-4">
                    <h5 class="text-primary">Welcome Back !</h5>
                    <p>Sign in to continue to Chevicar.</p>
                  </div>
                </div>
                <div class="col-5 align-self-end">
                  <!-- <img src="assets/images/profile-img.png" alt="" class="img-fluid"> -->
                </div>
              </div>
            </div>
            <div class="card-body pt-0">
              <div>
                <a href>
                  <div class="avatar-md profile-user-wid mb-4">
                    <span class="avatar-title rounded-circle bg-white">
                      <img src="@/assets/images/logo-chevy.png" alt class="rounded-circle" height="34" />
                    </span>
                  </div>
                </a>
              </div>
              <div class="p-2">
                <form class="form-horizontal" @submit.prevent="login">
                  <div class="form-group">
                    <label for="Email">Email</label>
                    <input
                      type="email"
                      id="Email"
                      placeholder="Email"
                      :class="(error.email != null) ? 'is-invalid form-control' : 'form-control'"
                      v-model="post.email"
                      required
                    />
                    <div
                      class="invalid-feedback"
                      v-if="error.email != null"
                    >{{ error.email.join() }}</div>
                  </div>

                  <div class="form-group">
                    <label for="userpassword">Password</label>
                    <input
                      type="password"
                      id="userpassword"
                      placeholder="password"
                      :class="(error.password != null) ? 'is-invalid form-control' : 'form-control'"
                      v-model="post.password"
                      required
                    />
                    <div
                      class="invalid-feedback"
                      v-if="error.password != null"
                    >{{ error.password.join() }}</div>
                  </div>

                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="customControlInline" />
                    <label class="custom-control-label" for="customControlInline">Remember me</label>
                  </div>

                  <div class="mt-3">
                    <b-button
                      v-if="disabled"
                      variant="primary"
                      class="btn btn-primary btn-block waves-effect waves-light"
                      disabled
                    >
                      <b-spinner small type="grow"></b-spinner>Log In...
                    </b-button>
                    <button
                      v-else
                      class="btn btn-primary btn-block waves-effect waves-light"
                      type="submit"
                    >Log In</button>
                  </div>

                  <div class="mt-4 text-center">
                    <a href class="text-muted">
                      <i class="mdi mdi-lock mr-1"></i> Forgot your password?
                    </a>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <!-- <div class="mt-3 text-center">
            <p>
              Don't have an account ?
              <a href class="font-weight-medium text-primary">Signup now</a>
            </p>
            <p class="mt-5">© 2020 Chevicare.</p>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      post: {
        admin: true
      },
      error: {},
      disabled: false
    };
  },
  methods: {
    login: function() {
      this.error = {};
      this.disabled = true;

      this.axios
        .post("/users/login", this.post)
        .then(response => {
          if (response.data.token != undefined) {
            localStorage.setItem("token", response.data.token);
            this.disabled = false;
            var users = {
              usr_fullname: response.data.user_name,
              usr_role: response.data.role,
              usr_admin: response.data.usr_admin,
              usr_photo: response.data.usr_photo,
            };
            localStorage.setItem("users", JSON.stringify(users));
            this.$router.push({ name: "dashboards" });
          }
          // router.push({ name: 'user', params: { userId: 123 }})
        })
        .catch(error => {
          console.log(error);

          this.disabled = false;
          if (error.response.data.error != undefined) {
            this.error = error.response.data.error;
          } else {
            this.error = error.response.data;
          }
        });
    }
  }
};
</script>